import LandingLeftyRighty from "./LandingLeftyRighty";
export default LandingLeftyRighty;